import { Capacitor, registerPlugin } from "@capacitor/core"

const PLUGIN_NAME = "InstallReferrer"

export type InstallReferrerDetails = {
	referrerUrl: string
	referrerClickTimestampSeconds: number
	appInstallTimestampSeconds: number
	referrerClickTimestampServerSeconds: number
	appInstallTimestampServerSeconds: number
	installVersion: string
	googlePlayInstantParam: boolean
	isFromRuStore?: boolean
}

export interface InstallReferrerPlugin {
	getReferrerDetails(): Promise<InstallReferrerDetails>
}

export const InstallReferrer =
	registerPlugin<InstallReferrerPlugin>(PLUGIN_NAME)

/**
 * Only the Android builds (`googleplay` and `rustore`) register the plugin. On
 * iOS, Telegram and the browser, the function gives `false`.
 */
export function isInstallReferrerAvailable(): boolean {
	return Capacitor.isPluginAvailable(PLUGIN_NAME)
}
